<template lang="pug">
  mixin modalConf
    app-modal(type="primary" v-model="isModalConfOpen")
      template(slot="title") 表示順の変更
      h4 選択したアイテムを移動します。よろしいですか？
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-primary(type="button" @click="$parent.$refs.sortableList.sendListSortRequest(true); close();") 移動
        button.btn.btn-default(type="button" @click="close") キャンセル

  //- 通常モード
  span(v-if="!$store.getState('isListSortMode')")
    slot(:toggleSortMode="toggleSortMode")

    app-modal(type="info" v-model="isModalNoitemOpen")
      h4 移動するアイテムを選択してください。

    +modalConf

  //- 表示順変更モード
  div(v-else) 移動先をクリックして表示順を変更するか、
    a(href="#" @click="toggleSortMode") 表示順変更モードを解除
    | &nbsp;してください。

    +modalConf

</template>

<script>
// AppListSortableListとセットで使います
import AppModal from '@/components/templates/AppModal'
export default {
  name: 'AppListSortNav',
  components: { AppModal },
  props: {
    enabled: {type: Boolean, required: false, default: true} // 有効無効の切り替え用
  },
  data: function () {
    return {
      isModalNoitemOpen: false,
      isModalConfOpen: false
    }
  },
  created: function () {
    // reset
    this.$store.commit('toggleListSortMode', false)
  },
  methods: {
    /**
     * 表示順変更モードの開始・終了
     */
    toggleSortMode: function (e) {
      if (!this.enabled) {
        return
      }
      if (!this.$parent.checkedIds.length) {
        this.isModalNoitemOpen = true
        return
      }
      this.$store.commit('toggleListSortMode')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/AppListSortableNav.vue